<svg [climbIcon]="icons.pencil"></svg>
